import { AnalyticsDashboard } from "./lazy-components"
import { navCategories } from "../common/constants"

import { tRoute, tDashboard } from "./types"
import demoBetaIconSrc from "../../images/sidebar_icons/demo-beta.svg"

export const getBetaAnalyticsRoutes = (dashboards: Array<tDashboard>): Array<tRoute> => {
    const analyticsRoutes: Array<tRoute> = []
    for (const dashboard of dashboards) {
        if (dashboard.category === "BETA" && dashboard.url) {
            const route: tRoute = {
                path: `/rhumbix/analytics/${dashboard.url_slug}/`,
                authRequired: true,
                component: AnalyticsDashboard,
                navTitle: dashboard.name,
                navIconSrc: demoBetaIconSrc,
                navCategory: navCategories.beta,
            }
            analyticsRoutes.push(route)
        }
    }
    return analyticsRoutes
}
